

















import { Component, Mixins } from 'vue-property-decorator'
import InputWithLabel from '@/components/molecules/InputWithLabel.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import LoginMethods from '@/components/organisms/LoginMethods.vue'

@Component({
  components: {
    InputWithLabel,
    ButtonBase,
  },
})
export default class Login extends Mixins(LoginMethods) {
  private gdlsCode = ''

  private password = ''

  private created() {
    this.mode = this.MODE.ADMIN
  }

  private async submitLogin() {
    if(this.gdlsCode.indexOf('admin-quiz') === 0){
      this.role = this.MODE.ADMIN_QUIZ
    }else {
      this.role = this.MODE.ADMIN
    }
    this.login(this.gdlsCode, this.password)
  }

  private toggleBodyClass(addRemoveClass: string, className: string): void {
    const el = document.body

    if (addRemoveClass === 'addClass') {
      el.classList.add(className)
    } else {
      el.classList.remove(className)
    }
  }

  private mounted() {
    this.toggleBodyClass('addClass', 'admin')
  }

  private destroyed(): void {
    this.toggleBodyClass('removeClass', 'admin')
  }
}
